import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import { useTranslation } from '../hooks/use-i18n'
import config from '../services/config'

interface FooterProps {
  /** Optional extra links (e.g. Companies, Arena). */
  showLinks?: boolean
  /** Optional extra class for the footer container. */
  className?: string
}

const Footer: React.FC<FooterProps> = ({ showLinks = false, className = '' }) => {
  const { t } = useTranslation()
  return (
    <footer className={`border-t border-muted/20 py-5 xs:py-6 sm:py-8 ${className}`.trim()}>
      <div className="container mx-auto px-3 xs:px-4 sm:px-6 text-center w-full max-w-full overflow-hidden">
        <div className="flex flex-col items-center gap-3 xs:gap-4">
          <Logo to="/" size="sm" className="shrink-0" />
          {showLinks && (
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 xs:gap-x-6 text-nav text-muted-foreground">
              <Link to="/company-registration" className="hover:text-foreground transition-colors whitespace-nowrap">{t('footer.companies')}</Link>
              <Link to="/arena" className="hover:text-foreground transition-colors whitespace-nowrap">{t('footer.arena')}</Link>
              <Link to="/showcase" className="hover:text-foreground transition-colors whitespace-nowrap">{t('footer.showcase')}</Link>
              <Link to="/about-us" className="hover:text-foreground transition-colors whitespace-nowrap">{t('footer.about')}</Link>
            </div>
          )}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-nav text-muted-foreground">
            <a
              href={`mailto:${config.contactEmail}`}
              className="hover:text-foreground transition-colors whitespace-nowrap"
            >
              {config.contactEmail}
            </a>
            <a
              href={config.socialMedias.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors whitespace-nowrap"
            >
              {t('footer.instagram')}
            </a>
          </div>
          <p className="text-body-lg text-muted-foreground text-center max-w-full break-words px-1">
            © 2026 breakroomcup. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
